import { useQuery } from "@tanstack/react-query";
import { getApiUsers } from "Infrastructure/Api/Api";

export const USERS_QUERY_KEY = "USERS_QUERY";

export function useUsersQuery() {
  const query = useQuery({
    queryKey: [USERS_QUERY_KEY],
    queryFn: () => getApiUsers(0, 100),
  });

  return query;
}
